import {LetterSubList} from "../../@types/privacyPolicySectionResources.tsx";
import LegalPageSectionParagraphTransComponent
    from "../legal-pages-components/LegalPageSectionParagraphTransComponent.tsx";

const LegalPageParagraphLetterList = ({list, locale}: {list: LetterSubList[], locale?: string}) => {
    return (
        <>
            <ol type="a">
                {list.map((listItem, index) => (
                    <li key={index} className="mb-4 mt-4 text-blue-dark">
                        <LegalPageSectionParagraphTransComponent text={listItem.text} locale={locale}/>
                        {listItem.romanSubList && <ol type="i">
                            {listItem.romanSubList.map((romanItem, romanIndex) => (
                                <li key={romanIndex} className="mb-4 mt-4 text-blue-dark">
                                    <LegalPageSectionParagraphTransComponent text={romanItem.text} locale={locale}/>
                                </li>
                            ))}
                        </ol>}
                    </li>
                ))}
            </ol>
        </>
    )
}

export default LegalPageParagraphLetterList;
